import HalfPriceTraffic from "@components/HalfPriceTraffic";
import Close from "assets/svg/close.svg";
import Location from "assets/svg/package-details/location.svg";
import Ofline from "assets/svg/package-details/ofline.svg";
import Online from "assets/svg/package-details/online.svg";
import Play from "assets/svg/play.svg";
import { Rating } from "components";
import React, { FC, useState } from "react";

import Modal from "../Modal";

type Props = {
  summaryVideo: string;
  summaryVideoName: string;
  title: string;
  description: string;
  percent: {
    offlinePercentage: number;
    onlinePercentage: number;
    inclassPercentage: number;
  };
};
const Head: FC<Props> = ({
  summaryVideo,
  summaryVideoName,
  title,
  description,
  percent: { inclassPercentage, offlinePercentage, onlinePercentage },
}) => {
  const [isShowVideoModal, setIsShowVideoModal] = useState(false);
  return (
    <>
      <Modal
        visible={isShowVideoModal}
        onClose={() => setIsShowVideoModal(false)}
        className="h-screen w-screen"
      >
        <div className="relative mx-auto h-60 w-10/12 rounded bg-black md:h-96 md:w-8/12 xl:h-190">
          <video
            autoPlay
            controls
            src={summaryVideo}
            className="h-full w-full"
          />
          <Close
            onClick={() => setIsShowVideoModal(false)}
            className="absolute top-5 left-5 cursor-pointer fill-white"
          />
          <HalfPriceTraffic
            classes="absolute top-[1rem] right-[1rem] z-50 rounded"
            type="VIDEO"
            spaces="pr-2 md:pr-4 !ml-2"
            text="هزینه اینترنت مصرفی : نیم‌بها"
          />
        </div>
      </Modal>
      <div
        className={`${
          !summaryVideo && "hidden lg:flex"
        } relative flex h-[224px] items-center bg-white shadow-md md:h-[463px] xl:h-[523px]`}
      >
        <div
          className={`${
            summaryVideo ? "absolute" : "relative"
          } absolute z-0 h-full w-full xl:w-[36%]`}
          style={{
            background:
              "linear-gradient(270deg, #366494 0%, #0480D4 50%, #27B2BC 100%)",
          }}
        >
          <img
            loading="lazy"
            alt={title}
            className="h-full"
            src="/images/backgrounds/white.png"
          />
        </div>
        <div
          className={`z-10 mx-auto flex w-full md:w-auto lg:px-5 2xl:px-[13%] ${
            !summaryVideo && "lg:px-[5%]"
          }`}
        >
          {summaryVideo && (
            <div className="relative m-auto mx-auto h-[164px] w-4/5 rounded-lg bg-white shadow-sm md:h-[363px] md:w-190 md:p-3 lg:w-[100%] xl:ml-10 xl:h-[315px]">
              <div className="absolute top-0 left-0 h-full w-full rounded"></div>
              <video
                src={summaryVideo}
                className="h-full w-full rounded object-cover"
              />
              <Play
                onClick={() => setIsShowVideoModal(true)}
                className="absolute top-1/2 left-1/2 h-16 w-16 -translate-y-1/2 -translate-x-1/2 cursor-pointer drop-shadow-lg"
              />
            </div>
          )}{" "}
          <div className="hidden flex-col justify-between px-5 lg:flex">
            <h1 className="text-[45px] font-bold">{title}</h1>
            <p className="text-lg md:mb-4"> {description}</p>
            {/* <div className="flex text-sm md:mb-4">
                            <span className="mx-1 md:mb-4">
                                <Rating value={4} readOnly />
                            </span>
                            <span>امتیاز دوره از نظر کاربران</span>
                        </div> */}
            <div className="flex gap-x-14 text-sm">
              <div className="flex items-center gap-x-6 whitespace-nowrap">
                <Online className="h-[30px]" />% {onlinePercentage} آنلاین
              </div>
              <div className="flex items-center gap-x-6 whitespace-nowrap">
                <Ofline className="h-[30px]" />% {offlinePercentage} آفلاین
              </div>
              <div className="flex items-center gap-x-6 whitespace-nowrap">
                <Location className="h-[30px]" />% {inclassPercentage} حضوری
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-between gap-y-[30px] py-[30px] px-[10%] shadow-md lg:hidden">
        <h1 className="text-lg font-bold md:text-[25px]">{title}</h1>
        <p className="text-xs md:text-[15px]"> {description}</p>
        {/* <div className="flex text-sm">
                    <span className="mx-1">
                        <Rating value={4} readOnly />
                    </span>
                    <span>امتیاز دوره از نظر کاربران</span>
                </div> */}
        <div className="flex items-center justify-between text-sm md:justify-start md:gap-x-14 md:text-base">
          <div className="flex items-end gap-x-1 text-xs md:gap-x-5 md:text-sm lg:gap-x-6">
            <Online className="h-3 w-4 text-xs md:h-5 md:w-auto" />%{" "}
            {onlinePercentage} آنلاین
          </div>
          <div className="flex items-end gap-x-1 text-xs md:gap-x-5 md:text-sm lg:gap-x-6">
            <Ofline className="h-3 w-4 text-xs md:h-5 md:w-auto" />%{" "}
            {offlinePercentage} آفلاین
          </div>
          <div className="flex items-end gap-x-1 text-xs md:gap-x-5 md:text-sm lg:gap-x-6">
            <Location className="h-3 w-4 text-xs md:h-5 md:w-auto" />%{" "}
            {inclassPercentage} حضوری
          </div>
        </div>
      </div>
    </>
  );
};

export default Head;
